import React from "react";
import PropTypes from "prop-types";

/**
 * Tabs.Panel
 *  - Wrapper for Contents to display on Each Tab
 */
export function Panel(props) {
  return <div className={props.className}>{props.children}</div>;
}

Panel.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * List of Children components
   */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
  /**
   * Unqiue string pointing to Menu
   *  - should be the same strng as the value prop passed to Menu Component
   */
  menuValue: PropTypes.string.isRequired,
};

Panel.defaultProps = {
  className: "",
};
